"use strict";const _jsxFileName = "/home/runner/work/bloom-mono/bloom-mono/apps/frontend/webChat/src/screens/Broadcast/EmptyCampaignPage.tsx";Object.defineProperty(exports, "__esModule", {value: true}); function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }var _react = require('react'); var _react2 = _interopRequireDefault(_react);

var _myRelations = require('shared/selectors/myRelations');
var _hooks = require('web/services/hooks');

var _TemplateEntityScreen = require('web/screens/TemplateEntityScreen'); var _TemplateEntityScreen2 = _interopRequireDefault(_TemplateEntityScreen);

const EmptyCampaignPage = () => {
  const doIHaveAnyPhoneTeams = _hooks.useAppSelector.call(void 0, _myRelations.selectDoIHaveAnyPhoneTeams)

  return (
  _react2.default.createElement(_TemplateEntityScreen2.default, {
    iconSrc: "/assets/icons/broadcast/broadcast-lightgrey.svg",
    title: "Campaigns",
    desc: doIHaveAnyPhoneTeams
      ? _react2.default.createElement(_react2.default.Fragment, null, "Your campaigns are listed on the left. "
                 , _react2.default.createElement('wbr', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 17}} ), "Choose one to see more details."

        )
      : _react2.default.createElement('b', {__self: this, __source: {fileName: _jsxFileName, lineNumber: 20}}, "To use this feature, you must be a member of a team with an assigned phone number."

        )
    , __self: this, __source: {fileName: _jsxFileName, lineNumber: 12}}
  )
  )
}

exports. default = _react.memo.call(void 0, EmptyCampaignPage)
